export default {
	home: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_create_new_app_4_steps.mp4',
	createNewApp: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_add_profile.mp4',
	updateAppTemplate: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_update_template.mp4',
	userAppsViewer: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_view_user_apps.mp4',
	appDetailViewerTest: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_app_details_viewer_test.mp4',
	appDetailViewerPublish: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_app_details_viewer_publish.mp4',
	appReportViewer: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_report.mp4',
	manageUsers: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_manage_users.mp4',
	userInstructions: 'https://s3-us-west-2.amazonaws.com/system-data/web-app/tutorials/tutorial_user_instructions.mp4',
};



// WEBPACK FOOTER //
// ./src/documents/tutorial.js